const fetchModule = (moduleUrl, moduleId) => {
  return fetch(moduleUrl)
    .then((res) => res.text())
    .then((res) => {
      const parser = new DOMParser();
      const htmlDocument = parser.parseFromString(res, "text/html");
      const module = htmlDocument.documentElement.querySelector(
        `[class*=${moduleId}]`
      );

      return module?.outerHTML;
    })
    .catch((err) => {
      console.error(
        `[Shopify Content Switch] Failed to load content for moduleUrl: ${moduleUrl}`,
        err
      );
    });
};

let isModuleSetting = false;

const setModule = async (page, title) => {
  if (isModuleSetting) {
    return; // Block further execution if the function is already running
  }

  isModuleSetting = true; // Set the flag to indicate the function is running

  const heroModule = document.querySelector("[class*=heroModule-true]");
  const productPromotionModule = document.querySelector(
    "[class*=productPromotionModule-true]"
  );
  const ctaModule = document.querySelector("[class*=ctaModule-true]");

  const listOfModules = [
    { element: heroModule, id: "heroModule", url: page },
    {
      element: productPromotionModule,
      id: "productPromotionModule",
      url: page,
    },
    { element: ctaModule, id: "ctaModule", url: page },
  ];

  // Start fade-out for all modules
  listOfModules.forEach(({ element }) => {
    if (element) {
      element.classList.add("fade-out");
    }
  });

  // Fetch all new content in parallel
  const fetchPromises = listOfModules.map(({ id, url }) =>
    fetchModule(url, id)
  );

  // Wait for all fade-out transitions to complete
  const transitionPromises = listOfModules.map(({ element }) => {
    return new Promise((resolve) => {
      if (element) {
        element.addEventListener("transitionend", resolve, { once: true });
      } else {
        resolve();
      }
    });
  });

  try {
    const responses = await Promise.all([
      ...fetchPromises,
      ...transitionPromises,
    ]);

    // Update the innerHTML for all modules and start fade-in
    listOfModules.forEach(({ element }, index) => {
      if (element) {
        const response = responses[index];
        element.innerHTML = response;

        element.classList.remove("fade-out");
        element.classList.add("fade-in");

        // Remove the fade-in class after the transition
        element.addEventListener(
          "transitionend",
          () => {
            element.classList.remove("fade-in");
          },
          { once: true }
        );
      }
    });
  } catch (error) {
    console.error("Error in setModule:", error);
  } finally {
    // console.log("page:", page, "title:", title);

    // localStorage.setItem("currentPage", page); // Save the current page to localStorage
    // localStorage.setItem("currentTitle", title); // Save the current title to localStorage
    const allButtons = document.querySelectorAll("[id*=content-switch-button]");

    allButtons.forEach((button) => {
      // Remove the sand text color class if it exists
      button.classList.remove("text-black");
      button.classList.remove("bg-white");

      // Add the black text color class
      button.classList.add("text-white");
    });

    // Select the button with the specific title
    const specificButton = document.querySelector(
      `[id*=content-switch-button-${title}]`
    );

    if (specificButton) {
      // Remove the black text color class
      specificButton.classList.remove("text-white");

      // Add the selected classes
      specificButton.classList.add("text-black");
      specificButton.classList.add("bg-white");
    }

    isModuleSetting = false; // Reset the flag once the function is done
  }
};
